export const IMAGE_FILE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp']

export const extractExtension = (name: string) => {
  const index = name.lastIndexOf('.')
  return { name: name.substring(0, index), extension: name.substring(index + 1) }
}

export const isImageFileExtension = (extension: string) => {
  return IMAGE_FILE_EXTENSIONS.includes(extension.toLowerCase())
}

export const isImageFileName = (fileName: string) => {
  return isImageFileExtension(extractExtension(fileName).extension)
}

// テキストをファイルとしてダウンロードさせる（CSVはBOM付きUTF-8でExcel対応）
export const downloadTextFile = (
  text: string,
  fileName: string,
  options?: { mimeType?: string; withBom?: boolean }
) => {
  const bom = options?.withBom ? '\ufeff' : ''
  const blob = new Blob([bom + text], {
    type: options?.mimeType ?? 'text/plain;charset=utf-8;'
  })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
